// extracted by mini-css-extract-plugin
module.exports = {"form":"SelectInitTemplates_form__1DwCd","field":"SelectInitTemplates_field__2uzF7"};